module.exports = __webpack_public_path__ + "static/media/1.0.1.31aa1d72.md";